<template>
    <div class="form-group">
        <label :for="field" v-if="label">{{ label }}</label>
        <div class="input-group" :class="{disabled: disabled}">
            <DatePicker readonly
                        :disabled="disabled"
                        :id="field"
                        class="form-control"
                        :class="{'is-invalid': errors && errors.has(field)}"
                        autocomplete="off"
                        :placeholder="placeholder"
                        :value="toValue"
                        @input="inputDate($event)"
                        :config="{
                  dateFormat: flatPickrInputFormat,
                  locale: {
                    firstDayOfWeek: 1,
                  },
                  allowInput: true,
                  time_24hr: true,
                  enableTime: type === 'datetime',
                }"/>
            <div class="input-group-btn" v-if="toValue && allowEmpty">
                <button class="btn btn-default" @click="inputDate(null)" :disabled="disabled">
                    <i class="material-icons md-18">clear</i>
                </button>
            </div>
        </div>
        <slot></slot>
        <AppError v-if="errors" :errors="errors" :field="field"/>
    </div>
</template>

<script>
import DatePicker from 'vue-flatpickr-component';
import AppError from './AppError';
import { formatDate } from '../../filters/date.filter';

const tokenTable = {
  YYYY: 'Y',
  MMM: 'M',
  MM: 'm',
  DD: 'd',
  D: 'j',
  HH: 'H',
  mm: 'i',
  ss: 'S',
};

export default {
  components: {
    AppError,
    DatePicker,
  },
  props: {
    errors: {},
    label: {},
    value: {},
    placeholder: {},
    field: {},
    disabled: {},
    allowEmpty: {
      default: false,
    },
    displayFormat: {},
    modelFormat: {},
    type: {
      default: 'date',
    },
  },
  computed: {
    displayFormatCalc() {
      return this.displayFormat || (this.type === 'datetime' ? 'D MMM YYYY HH:mm' : 'D MMM YYYY'); // Day.js syntax
    },
    modelFormatCalc() {
      return this.modelFormat || 'YYYY-MM-DD HH:mm:ss'; // Day.js syntax
    },
    flatPickrInputFormat() {
      let format = this.displayFormatCalc;
      Object.keys(tokenTable)
        .forEach((token) => {
          format = format.replace(token, tokenTable[token]);
        });
      return format;
    },
    toValue() {
      return formatDate(this.value, this.displayFormatCalc, this.modelFormatCalc);
    },
  },
  methods: {
    inputDate(val) {
      this.$emit('input', this.toModelFormat(val));
    },
    toModelFormat(val) {
      return formatDate(val, this.modelFormatCalc, this.displayFormatCalc, true);
    },
  },
};
</script>
<style lang="scss">
    @import '~flatpickr/dist/flatpickr.min.css';
</style>
